module.exports = __webpack_public_path__ + "img/dod_23_01.222fb4aa.jpg";